import React, { useEffect, useRef } from 'react';
import Navbar from '../components/Navbar';
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { getReportingCreds } from '../api/api';

const DataInput: React.FC = () => {
  const container = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    getReportingCreds().then(creds => {
        /* The fetchGuestToken should on it's first go use the initial guest token, and then  we'll make a fresh
        request to the backend for a new token (I'm guessing this might happen if the token expires).       */
        let initialToken : string | undefined = creds.guest_token;

        embedDashboard({
          id: creds.dashboard_ids[0], // we may offer multiple Cyrenians dashboards in future, so this is an array on the backend
          supersetDomain: "https://superset.tfga.app",
          mountPoint: container.current!,
          fetchGuestToken: async () => {
            if (initialToken) {
              const ret = initialToken;
              initialToken = undefined;
              return ret;
            } else {
              const creds = await getReportingCreds();
              return creds.guest_token;
            }
          },
          dashboardUiConfig: {
            hideTitle: true,
            filters: {expanded: true },
            urlParams: { }
          },
          iframeSandboxExtras: ['allow-top-navigation', 'allow-popups-to-escape-sandbox']
        });

    })
  }, []);


  return (
    <div className="flex flex-col h-screen bg-gray-50">
      <Navbar />
      <main className="flex-1 w-full overflow-hidden" id='superset-container' ref={container}>
        Loading Apache Superset Dashboard....
      </main>
     <style>{`
      #superset-container > iframe {
        width: 100%;
        height: 100%;
     `}</style>
    </div>

  );
};

export default DataInput;
